import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { urlQuery } from "../../../utils/helpers";
import {
  addUserData,
  setPlaceOrderData,
  checkLastScreen,
} from "../../../redux/actions";
import { dateFormatter, showFromToTime } from "../../../utils/helpers";
import { ModalRecoverySent } from "../../../modals/ModalRecoverySent.jsx";

import Notification from "../components/Notification";
import translation from "../../../translations/ThirdStep";
import "./ModernThirdStep.scss";

const ThirdStep = (props) => {
  const lang = localStorage.getItem("lang");
  const {
    selectedPickupTime,
    selectedDeliveryTime,
    selectedPickupDate,
    selectedDeliveryDate,
    placeOrderData,
    setPlaceOrderData,
    notification,
  } = props;

  const setUserNote = (e) => {
    const notes = e.target.value;
    const data = { ...placeOrderData, notes };
    setPlaceOrderData(data);
  };

  return (
    <div className="modern-third-step">
      {notification.status && <Notification />}
      <div className="modern-card">
        <div className="modern-step-hero">
          <h1 className="modern-step-title">{translation.title[lang]}</h1>
        </div>

        {/* Service Overview */}
        <div className="modern-service-overview">
          <div className="modern-service-grid">
            <div className="modern-service-item">
              <div className="service-type">{translation.pickUp[lang]}</div>
              <div className="service-details">
                <div className="service-detail">
                  {dateFormatter(selectedPickupDate.date)}
                </div>
                <div className="service-detail">
                  {showFromToTime(selectedPickupTime)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Notes Section */}
        <div className="modern-notes-section">
          <h2 className="modern-card-title">{translation.note[lang]}</h2>
          <div className="modern-textarea-wrapper">
            <textarea
              id="step-5-order-textarea-note"
              className="modern-textarea"
              placeholder={translation.noteSub[lang]}
              onChange={setUserNote}
              value={placeOrderData.notes ? placeOrderData.notes : ""}
            />
          </div>
        </div>

        {/* Contact Details */}
        <ContactDetails {...props} />
      </div>
    </div>
  );
};

class ContactDetails extends React.Component {
  state = {
    modalRecoverySent: false,
    userEmail: "",
  };

  setUserData = (e) => {
    const { userData, addUserData } = this.props;
    switch (e.target.name) {
      case "contactPhone": {
        const contactPhone = e.target.value;
        const data = { ...userData, contactPhone };
        addUserData(data);
        break;
      }
      case "contactName": {
        const contactName = e.target.value;
        const data = { ...userData, contactName };
        addUserData(data);
        break;
      }
      case "contactEmail": {
        const contactEmail = e.target.value;
        const data = { ...userData, contactEmail };
        addUserData(data);
        break;
      }
      default:
        break;
    }
  };

  handleCheckboxToggle = (e) => {
    const { checkLastScreen } = this.props;
    checkLastScreen(e.target.checked);
  };

  componentDidMount() {
    this.props.history.push(urlQuery({ page: "confirm-order" }));
    try {
      window.dataLayer.push({ event: "order-overview" });
    } catch (err) {
      console.log("Error", err);
    }
  }

  render() {
    const lang = localStorage.getItem("lang");

    return (
      <div className="modern-contact-section">
        <h2 className="modern-card-title">
          {translation.contactDetailsSub[lang]}
        </h2>

        <div className="modern-form-grid">
          <div className="modern-input-group">
            <input
              id="step-5-user-input-name"
              className="modern-input"
              placeholder={translation.name[lang]}
              name="contactName"
              type="text"
              onChange={this.setUserData}
            />
          </div>

          <div className="modern-input-group">
            <input
              id="step-5-user-input-phone"
              className="modern-input"
              placeholder={translation.phoneNumber[lang]}
              name="contactPhone"
              onChange={this.setUserData}
              type="text"
            />
          </div>

          <div className="modern-input-group full-width">
            <input
              id="step-5-user-input-email"
              className="modern-input"
              placeholder={translation.email[lang]}
              name="contactEmail"
              onChange={this.setUserData}
              type="email"
            />
          </div>

          <div className="modern-checkbox-section">
            <input
              id="step-5-user-checkbox-order-updates"
              type="checkbox"
              defaultChecked={false}
              onChange={this.handleCheckboxToggle}
            />
            <label
              className="modern-checkbox-label"
              htmlFor="step-5-user-checkbox-order-updates"
              dangerouslySetInnerHTML={{
                __html: translation.keepInformedCompany[lang],
              }}
            />
          </div>
        </div>

        <ModalRecoverySent
          isOpen={this.state.modalRecoverySent}
          email={this.state.userEmail}
          lang={lang}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  selectedPickupTime,
  selectedDeliveryTime,
  selectedPickupDate,
  selectedDeliveryDate,
  placeOrderData,
  userData,
  orderData,
  apiToken,
  notification,
  checkedLastScreen,
}) => ({
  selectedPickupTime,
  selectedDeliveryTime,
  selectedPickupDate: selectedPickupDate,
  selectedDeliveryDate: selectedDeliveryDate,
  placeOrderData,
  userData,
  orderData,
  token: apiToken,
  notification,
  checkedLastScreen,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addUserData: (data) => dispatch(addUserData(data)),
    checkLastScreen: (data) => dispatch(checkLastScreen(data)),
    setPlaceOrderData: (data) => dispatch(setPlaceOrderData(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ThirdStep);
